<template>
  <div class="register absolute login-wrapper">
    <div class="shading">
      <div class="pictrue acea-row row-center-wrapper">
        <!-- <img :src="logoUrl" v-if="logoUrl" />
          <img src="@assets/images/logo2.png" v-else /> -->
      </div>
    </div>
    <div>
      <div class="helloClass">您好!</div>
      <div class="welcomeClass">欢迎来到【小将商城】</div>
    </div>
    <div class="whiteBg addpadding" v-if="formItem === 1">
      <div class="title acea-row row-center-wrapper">
        <div class="item" :class="current === index ? 'on' : ''" v-for="(item, index) in navList" @click="navTap(index)"
          :key="index">
          {{ item }}
        </div>
      </div>
      <div class="list" :hidden="current !== 0">
        <form @submit.prevent="submit">
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-phone_"></use>
              </svg>
              <input type="text" placeholder="输入手机号码" v-model="account" required />
            </div>
          </div>
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <input type="password" placeholder="填写登录密码" v-model="password" required />
            </div>
          </div>
        </form>
        <div class="forgetPwd" @click="$router.push({ name: 'RetrievePassword' })">
          <span class="iconfont icon-wenti"></span>忘记密码
        </div>
      </div>
      <!-- 手机号 -->

      <!-- 扫码登录测试 -->
      <div class="scanCode">
        <input class="scanCode" type="text" placeholder="请输入登录码" v-model="scanCode" />
      </div>

      <div v-if="false">
        <div class="list" :hidden="current !== 1">
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-phone_"></use>
              </svg>
              <input type="text" placeholder="输入手机号码" v-model="account" />
            </div>
          </div>

          <div class="acea-row row-between row-bottom item two-item">
            <input type="text" placeholder="验证码" class="codeInput" v-model="imgCode" />
            <img class="img-code" @click="getCapt" :src="imgCodeUrl" />
          </div>

          <div class="item">
            <div class="align-left">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-code_1"></use>
              </svg>
              <input type="text" placeholder="填写短信验证码" class="codeIput" v-model="captcha" maxlength="6" />
              <button class="code" :disabled="disabled" :class="disabled === true ? 'on' : ''" @click="code">
                {{ text }}
              </button>
            </div>
          </div>
          <div class="item" v-if="isShowCode">
            <div class="align-left">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <input type="text" placeholder="填写验证码" class="codeIput" v-model="codeVal" />
              <div class="code" @click="again"><img :src="codeUrl" /></div>
            </div>
          </div>
        </div>
      </div>
      <div class="logon" @click="loginMobile" :hidden="current !== 1">登录</div>
      <div class="logon" @click="submit" :hidden="current === 1">登录</div>
      <!-- <div class="tip">
          没有账号?
          <span @click="formItem = 2" class="font-color-red">立即注册</span>
        </div> -->
    </div>
    <div class="whiteBg" v-else>
      <div class="title">注册账号</div>
      <div class="list">
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <input type="text" placeholder="输入手机号码" v-model="account" />
          </div>
        </div>
        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input type="text" placeholder="填写验证码" class="codeIput" v-model="captcha" />
            <button class="code" :disabled="disabled" :class="disabled === true ? 'on' : ''" @click="code">
              {{ text }}
            </button>
          </div>
        </div>
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input type="password" placeholder="填写您的登录密码" v-model="password" />
          </div>
        </div>
        <div class="item" v-if="isShowCode">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input type="text" placeholder="填写验证码" class="codeIput" v-model="codeVal" />
            <div class="code" @click="again"><img :src="codeUrl" /></div>
          </div>
        </div>
      </div>
      <div class="logon" @click="register">注册</div>
      <div class="tip">
        已有账号?
        <span @click="formItem = 1" class="font-color-red">立即登录</span>
      </div>
    </div>
    <!-- <div class="bottom"></div> -->
    <!-- <DragSlider v-if="slider" @isOk="successFn" @close="isShowSlider"></DragSlider> -->
    <!-- 登录提示弹窗 -->
    <Overlay :show="isShow" duration="0">
      <div class="dialog-warp">
        <div class="size1">此微信账号已绑定<span>{{ prompt }}</span></div>
        <div class="size2">请更换此手机号登录</div>
        <div class="size3">*如需更换绑定手机，请致电客服热线 400-003-5989</div>
        <div class="button">
          <div class="buttonson" @click="isShow = false">确 定</div>
        </div>
      </div>
    </Overlay>

  </div>
</template>
<script>
import DragSlider from "@components/DragSlider.vue";
import sendVerifyCode from "@mixins/SendVerifyCode";
// import preventBack from "vue-prevent-browser-back";
import {
  login,
  loginMobile,
  registerVerify,
  register,
  getCodeApi,
  getCaptcha,
  mobilCheck,
  scanCodeApi
} from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { getLogo } from "@api/public";
import cookie from "@utils/store/cookie";
import { VUE_APP_API_URL, isWeixin } from "@utils";
import { Overlay } from "vant";
const BACK_URL = "login_back_url";
const LOGIN_KEY = "login_status";
let toName = "";

export default {
  name: "Login",
  components: {
    DragSlider, Overlay
  },
  mixins: [sendVerifyCode],
  // mixins: [sendVerifyCode],
  data: function () {
    return {
      // navList: ["账号登录", "快速登录"],
      navList: [" "],
      current: 1,
      //扫码登录默认登录
      account: "15711093465",
      password: "",
      // 扫码登录默认
      captcha: "xjwhhh",
      formItem: 1,
      type: "login",
      logoUrl: "",
      keyCode: "",
      codeUrl: "",
      codeVal: "",
      isShowCode: false,
      prompt: '',
      isShow: false,
      slider: false, //滑块
      imgCode: "", //图片验证码字
      imgCodeUrl: "https://shop.xiaojiangwh.com/api/login/captcha", //图片验证码图
      scanCode: '',
    };
  },
  mounted: function () {
    this.preBack();
    this.getCode();
    this.getLogoImage();
  },
  methods: {
    getCapt: function () {
      let imgPath = this.imgCodeUrl.split('?')[0] + '?id=' + parseInt(Math.random() * 100000);
      this.imgCodeUrl = imgPath;
    },
    // successFn: function () {
    //     this.isShowSlider(false);
    //     this.getCodeNum();
    // },
    getCodeNum: async function () {
      let that = this;
      if (that.formItem == 2) that.type = "register";
      await registerVerify({
        phone: that.account,
        type: that.type,
        key: that.keyCode,
        code: that.codeVal,
        verify: that.imgCode
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          if (res.data.status === 402) {
            that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
            that.isShowCode = true;
          }
          that.$dialog.error(res.msg);
        });
    },
    preBack: function () {
      // console.log("来了");
      // if (cookie.get(BACK_URL) && cookie.get(BACK_URL).indexOf('festivalName') === -1 && cookie.get(BACK_URL).indexOf('/festival') === -1) {
      //   console.log("木有");
      history.pushState(null, null, document.URL);
      // }
      window.addEventListener('popstate', this.onPopstate);
    },
    onPopstate: function () {
      // console.log("监听---");
      if (cookie.get(LOGIN_KEY) && cookie.get('isbind')) {
        // console.log("已登录");
        window.removeEventListener('popstate', this.onPopstate);
        return;
      }
      if (cookie.get('temporary_token') && !cookie.get('isbind') && toName === "BindCoupon") {
        // console.log("绑卡")
        toName = "";
        return;
      }
      // if (cookie.get(BACK_URL) && (cookie.get(BACK_URL).indexOf('festivalName') !== -1 || cookie.get(BACK_URL).indexOf('/festival') !== -1) && !cookie.get('isbind')) {
      //   console.log("返回去");
      //   return;
      // }
      history.pushState(null, null, document.URL);
    },
    again() {
      this.codeUrl =
        VUE_APP_API_URL +
        "/sms_captcha?" +
        "key=" +
        this.keyCode +
        Date.parse(new Date());
    },
    getCode() {
      getCodeApi()
        .then(res => {
          this.keyCode = res.data.key;
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    async getLogoImage() {
      let that = this;
      getLogo(2).then(res => {
        that.logoUrl = res.data.logo_url;
      });
    },
    async loginMobile() {
      var that = this;
      const { account, captcha, scanCode } = that;
      //扫码登录体验
      if (!scanCode) return this.$dialog.toast({ mes: '请输入登录码' })
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ]
          })
          .validate({ account, captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      scanCodeApi({
        phone: that.account,
        captcha: that.captcha,
        spread: cookie.get("spread"),
        is_weixin: isWeixin(),
        uid: sessionStorage.getItem('UID'),
        opid: sessionStorage.getItem('OPID'),
        type:2,
        scanCode:that.scanCode,
      }).then(res => {
        // this.prompt = res.data.prompt
        // if (res.data.prompt == '') {
        //   loginMobile({
        //     phone: that.account,
        //     captcha: that.captcha,
        //     spread: cookie.get("spread"),
        //     is_weixin: isWeixin(),
        //     uid: sessionStorage.getItem('UID'),
        //     opid: sessionStorage.getItem('OPID'),
        //     type:2,
        //     scanCode:that.scanCode,
        //   })
        //     .then(res => {
              let data = res.data;
              let expires_time = data.expires_time.substring(0, 19);
              expires_time = expires_time.replace(/-/g, "/");
              expires_time = new Date(expires_time).getTime() - 28800000;
              const datas = {
                token: data.token,
                expires_time: expires_time
              };
              //判断有没有绑卡
              let card = data.is_bind;
              if (card) {
                that.$store.commit("LOGIN", datas);
                cookie.set('isbind', true);
                const backUrl = cookie.get(BACK_URL) || "/";
                that.$router.replace({ path: backUrl });
                cookie.remove(BACK_URL);
              } else {
                cookie.set('isbind', false);
                cookie.set('temporary_token', datas.token || '');
                cookie.set('temporary_expires', datas.expires_time || '');
                this.$router.push({ path: "/user/bindcoupon", query: { id: 1 } });
              }
            // })
            // .catch(res => {
            //   that.$dialog.error(res.msg);
            // });
        // } else {
        //   this.isShow = true
        // }
      })
    },
    async register() {
      var that = this;
      const { account, captcha, password } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ],
            password: [
              required(required.message("密码")),
              attrs.range([6, 16], attrs.range.message("密码")),
              alpha_num(alpha_num.message("密码"))
            ]
          })
          .validate({ account, captcha, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      register({
        account: that.account,
        captcha: that.captcha,
        password: that.password,
        spread: cookie.get("spread")
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.formItem = 1;
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    // isShowSlider(val) {
    //   this.slider = val;
    // },
    async code() {
      var that = this;
      const { account } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ account });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      // this.isShowSlider(true);
      //验证-验证码
      if (this.imgCode) {
        this.getCodeNum();
      } else {
        that.$dialog.error("请输入验证码！");
      }
    },
    navTap: function (index) {
      this.current = index;
    },
    async submit() {
      const { account, password, codeVal } = this;
      try {
        await this.$validator({
          account: [
            required(required.message("账号")),
            attrs.range([5, 16], attrs.range.message("账号")),
            alpha_num(alpha_num.message("账号"))
          ],
          password: [
            required(required.message("密码")),
            attrs.range([6, 16], attrs.range.message("密码")),
            alpha_num(alpha_num.message("密码"))
          ],
          codeVal: this.isShowCode
            ? [
              required(required.message("验证码")),
              attrs.length(4, attrs.length.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ]
            : []
        }).validate({ account, password, codeVal });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      login({ account, password, code: codeVal })
        .then(({ data }) => {
          let expires_time = data.expires_time.substring(0, 19);
          expires_time = expires_time.replace(/-/g, "/");
          expires_time = new Date(expires_time).getTime() - 28800000;
          const datas = {
            token: data.token,
            expires_time: expires_time
          };
          this.$store.commit("LOGIN", datas);
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          this.$router.replace({ path: backUrl });
        })
        .catch(e => {
          this.$dialog.error(e.msg);
        });
    }
  },
  // beforeRouteLeave: function (to, from, next) {
  //   // console.log(to, from, "从登录页离开之前-");
  //   if (from.name === "Login" && cookie.get('temporary_token') && to.name === "BindCoupon") { // 去绑卡
  //     toName = to.name;
  //     next();
  //     return;
  //   }
  //   if (from.name === "Login" && cookie.get(LOGIN_KEY) && cookie.get('isbind')) { //登陆成功
  //     next();
  //     return;
  //   };
  //   next({ replace: true, redirect: '/login' });
  // }

};
</script>
<style scoped>
.code img {
  width: 100%;
  height: 100%;
}

.helloClass {
  width: 100%;
  padding: 1.5rem 0.2rem 0rem 1rem;
  font-family: PINGFANG HEAVY, sans-serif;
  font-size: 0.7rem;
}

.welcomeClass {
  width: 100%;
  padding: 0rem 0.2rem 0rem 1rem;
  font-family: PINGFANG HEAVY, sans-serif;
  font-size: 0.5rem;
}

.login-wrapper {
  background: transparent;
  background-image: url(../../assets/images/loginBg.jpg);
  background-size: 100%;
  background-repeat: no-repeat;
}

.login-wrapper .pictrue {
  border-radius: 0;
  background: transparent;
  width: 2.72rem;
  height: auto;
}

.login-wrapper .pictrue img {
  width: 100%;
  border-radius: 0;
  height: auto;
}

.addpadding {
  padding-bottom: .3rem;
}

.img-code {
  width: 2rem;
  height: .8rem;
}

.codeInput {
  width: 3.4rem !important;
  height: .38rem;
  box-sizing: border-box;
  padding-left: .3rem;
}

.two-item {
  padding-top: .3rem !important;
}

.scanCode {
  width: 100%;
  height: 40px;
  background: #f6f6f6;
  border-radius: 0.4rem 0.4rem 0.4rem 0.4rem;
  padding-left: 0.2rem;
}
</style>
